import { Link } from 'react-router-dom';
import { rankingList } from '@/mocks/ranking';
import { categories } from '@/mocks/categories';
import RankingList from '@/components/feature/RankingList';

export default function RankingBoard() {
  return (
    <section className="border-b border-background-200 bg-background-100 py-12 md:py-16" aria-labelledby="ranking-heading">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
              <div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-bar-chart-2-line text-sm" />
                  </span>
                  每 15 分钟刷新
                </span>
                <h2 id="ranking-heading" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  全网热搜榜
                </h2>
              </div>
              <Link
                to="/ranking"
                className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-primary-700 transition-colors hover:text-primary-600"
              >
                完整榜单
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line text-base" />
                </span>
              </Link>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 px-4 py-2 md:px-5">
              <RankingList items={rankingList.slice(0, 8)} />
            </div>
          </div>

          <div className="lg:col-span-5">
            <h2 className="mb-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">按频道找料</h2>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex cursor-pointer items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900 transition-colors group-hover:bg-primary-100 group-hover:text-primary-800">
                    <i className={`${cat.icon} text-xl`} />
                  </span>
                  <span className="min-w-0">
                    <span className="flex items-center gap-2">
                      <span className="font-heading text-sm font-bold text-foreground-950">{cat.name}</span>
                      <span className="text-[11px] text-foreground-500">{cat.count} 条</span>
                    </span>
                    <span className="mt-1 line-clamp-2 block text-xs leading-relaxed text-foreground-600">{cat.desc}</span>
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}